export default __webpack_public_path__ + "static/media/readyRed.28fa7019.svg";